module.exports = __webpack_public_path__ + "img/leovegas-logo.fa32d867.svg";